module.exports = __webpack_public_path__ + "static/media/21-1.0391b1e3.jpg";